export const PageConstant = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  HOME: '/specialists',
  CLIENTS: '/clients',

  _404: '/*',
}
